/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { HousePlanRestService, PriceBookRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import {
  HousePlanFinderFilter,
  HousePlanFinderListItem,
  PbHousePlanFinderFilter,
  PbHousePlanFinderListItem,
} from './house-plan-finder.model';

export interface HousePlanFinderDialogConfig extends FinderDialogConfig {
  sourceOfficeId: ID;
  filter?: Partial<HousePlanFinderFilter>;
  disableShowQqSwitcher?: boolean;
  disableShowSeSwitcher?: boolean;
}

export interface PbHousePlanFinderDialogConfig extends FinderDialogConfig {
  priceBookId: ID;
  priceBookName: string;
  filter?: Partial<PbHousePlanFinderFilter>;
}

@Injectable()
export class HousePlanFinderBusinessService {
  constructor(private housePlanRest: HousePlanRestService,
              private priceBookRest: PriceBookRestService) {

  }

  findAllAsDataSource(filter: HousePlanFinderFilter): SlicedDataSource<HousePlanFinderListItem> {
    return this.housePlanRest.findAllAsFinderDataSource(filter);
  }

  findAllPbHousePlansAsDataSource(filter: PbHousePlanFinderFilter): SlicedDataSource<PbHousePlanFinderListItem> {
    return this.priceBookRest.findRelatedHousePlansAsFinderDataSource({ ...filter, housePlans: [] });
  }
}
